import colorMod from 'color';

export default ({ color, typography }) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    width: 180,
  },
  inputBox: {
    flex: '0 0 57%',
    alignItems: 'center',
    '&:focus': {
      boxShadow: '0 0 0 1px #ffffff, 0 0 0 2px green',
      borderRadius: 1,
    },
  },
  daysLabel: {
    color: color.bodyText,
    display: 'inline-block',
    fontFamily: typography.bodyText,
    marginLeft: 8,
  },
  textInput: {
    width: 140,
    marginTop: 10,
    display: 'inline-block',
    marginBottom: 5,
    '& input': {
      width: 140,
      marginBottom: 0,
      height: 30,
      border: `1px solid ${color.borderColor}`,
      borderRadius: 3,
      fontSize: 13,
      fontFamily: typography.bodyText,
      '&:disabled': {
        color: color.bodyText,
        backgroundColor: colorMod(color.bodyText).alpha(0.05).string(),
      },
    },
  },
});